<template>
  <div class="row mr-0">
    <div class="col-sm-12 col-xs-12 col-md-12 p-0">
      <div class="filter-section">
        <div class="filter-compact">
          <div data-toggle="dropdown" class="filter-text-right cursor-pointer" :class="{ 'hide-field': !collapsed }"
            @click="showHideFilter()">
            <span class="dropdown-toggle cursor vertical-align-middle">
              <img src="/static/images/icons/filter_new.svg" class="accounts_filter" />
              <img src="/static/images/icons/accounts_right_chevron.svg" alt class="pl-9" />
            </span>
          </div>
          <div class="dropdown-menu dropdown-menu-left filter-ul" :class="{ 'hide-field': collapsed }">
            <div class="col-xs-12 p-0 filter-card-header">
              <div class="col-xs-12 p-0 d-flex align-center filter-chevron-section">
                <div data-toggle="dropdown" class="col-xs-1 filter-icon p-0">
                  <img src="/static/images/icons/filter_new.svg" alt="filter-icon" class="image-size" />
                </div>
                <div class="col-xs-11 inside-filter-text p-0">{{ $t('filter') }}</div>
                <div class="col-xs-1 pr-0">
                  <a @click="showHideFilter(true)">
                    <img src="/static/images/icons/filter_new_left_angle.svg" alt="chevronright-icon"
                      class="image-size cursor-pointer left-transform cursor" />
                  </a>
                </div>
              </div>
              <div class="col-xs-12 reset-apply-buttons">
                <button type="button" class="btn reset-link" @click="resetFilter">
                 {{ $t('resetAll') }}
                </button>
                <!-- <button type="button" class="btn apply-btn">
                  Apply
                </button> -->
              </div>
            </div>
            <div class="col-xs-12 filter-wrapper p-0">
              <div class="col-xs-12 account-status-carret-section p-0 filter-options-outline">
                <div class="filter-options">{{ $t('accountStatus') }}</div>
                <span>
                  <button data-toggle="collapse" data-target="#collapseAccountStatus" data-parent="#accordion">
                    <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="downCarret">
                    <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="upCarret">
                  </button>
                </span>
              </div>
              <div class="col-xs-12 collapse p-0" id="collapseAccountStatus">
                <ul role="menu" v-on:click.stop class="mb-0 p-0">
                  <li class="col-xs-12 record-type-item p-0 pt-25 pb-18">
                    <div class="col-xs-12 p-0 d-flex align-center">
                      <div class="col-xs-1 p-0 activityTracker-checkbox">
                        <span class="checkbox">
                          <label>
                            <input type="checkbox" v-model="activate" @change="filterData('active')" />
                            <span class="cr">
                              <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                            </span>
                          </label>
                        </span>
                      </div>
                      <div class="col-xs-10 pl-8 pr-0">
                        <span>{{ $t('Active') }}</span>
                      </div>
                    </div>
                  </li>
                  <li class="col-xs-12 record-type-item p-0 pb-18">
                    <div class="col-xs-12 p-0 d-flex align-center">
                      <div class="col-xs-1 p-0 activityTracker-checkbox">
                        <span class="checkbox">
                          <label>
                            <input type="checkbox" v-model="deactivate" @change="filterData('deactivate')" />
                            <span class="cr">
                              <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                            </span>
                          </label>
                        </span>
                      </div>
                      <div class="col-xs-10 pl-8 pr-0">
                        <span>{{ $t('deactivated') }}</span>
                      </div>
                    </div>
                  </li>
                  <!-- <li class="col-xs-12 record-type-item p-0">
                    <div class="col-xs-12 p-0 d-flex align-center">
                      <div class="col-xs-1 p-0 activityTracker-checkbox">
                        <span class="checkbox">
                          <label>
                            <input type="checkbox"/>
                            <span class="cr">
                              <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                            </span>
                          </label>
                        </span>
                      </div>
                      <div class="col-xs-10 pl-8 pr-0">
                        <span>Expired</span>
                      </div>
                    </div>
                  </li> -->
                </ul>
              </div>
              <div class="col-xs-12 account-status-carret-section p-0 filter-options-outline">
                <div class="filter-options">{{ $t('dateCreated') }}</div>
                <span>
                  <button data-toggle="collapse" data-target="#collapseCreatedDate" data-parent="#accordion">
                    <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="downCarret">
                    <img data-v-32d4f241="" src="/static/images/icons/filter_chevron_down.svg" class="upCarret">
                  </button>
                </span>
              </div>
              <div class="col-xs-12 collapse p-0" id="collapseCreatedDate">
                <ul role="menu" v-on:click.stop class="mb-0 p-0">
                  <li class="col-xs-12 record-type-item p-0 pt-25 pb-18 selected-box">
                    <div class="col-xs-12 p-0">
                      <label>
                        <input type="radio" value="7 days" v-model="selectedDate" @change="setData('date')" />
                        <span class="default-label">{{ $t('last7Days') }}</span>
                      </label>
                    </div>
                  </li>
                  <li class="col-xs-12 record-type-item p-0 pb-18">
                    <div class="col-xs-12 p-0">
                      <label>
                        <input type="radio" value="30 days" v-model="selectedDate" @change="setData('date')" />
                        <span class="default-label">{{ $t('last30Days') }}</span>
                      </label>
                    </div>
                  </li>
                  <li class="col-xs-12 record-type-item p-0 pb-18">
                    <div class="col-xs-12 p-0">
                      <label>
                        <input type="radio" value="within year" v-model="selectedDate" @change="setData('date')" />
                        <span class="default-label">{{ $t('withinLastYear') }}</span>
                      </label>
                    </div>
                  </li>
                  <li class="col-xs-12 record-type-item p-0 pb-18">
                    <div class="col-xs-12 p-0 d-flex">
                      <div class="col-xs-12 p-0">
                      <label>
                        <input type="radio" value="dates" v-model="selectedDate" @change="filterAccounts" />
                        <span class="default-label date-field">{{ $t('dateRange') }}:</span>
                      </label>
                      <filter-date ref="dateComponent" :showInAccountsFilter="false" :disabledDate="disabledDate" @dateRange=dateRange ></filter-date>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';
import getDateRange from '../UIComponents/mixins/dateRangeSelectionMixin';
import FilterDate from '../UIComponents/FilterDate.vue';

export default {
  mixins: [getDateRange],
  components: {
    FilterDate,
  },
  data() {
    return {
      collapsed: true,
      showInAccountsFilter: false,
      activate: false,
      deactivate: false,
      selectedDate: '',
      disabledDate: true,
    };
  },
  methods: {
    showHideFilter(isExpanded = false) {
      this.collapsed = !this.collapsed;
      console.log(isExpanded);
    },
    filterData(type) {
      this.$emit('updateStatus', this.activate, this.deactivate);
      // let
      console.log('check', type, this.deactivate, this.activate);
    },
    setData() {
      this.disabledDate = true;
      console.log('daata', this.selectedDate);
      let startDate = '';
      let endDate = '';
      if (this.selectedDate === '7 days') {
        // selects last 7 days

        startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
      } else if (this.selectedDate === '30 days') {
        startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
        endDate = moment().format('YYYY-MM-DD');
      } else if (this.selectedDate === 'within year') {
        // user selects year

        const date = moment();
        startDate = moment(date).year() - 1 + moment(date).format('-01-01');
        endDate = moment(date).year() - 1 + moment(date).format('-12-31');
        /* startDate  = moment().subtract(365, "days").format("YYYY-MM-DD")
                    endDate = moment().format('YYYY-MM-DD') */
      }
      this.$emit('updateDate', startDate, endDate);
      console.log('date', startDate, endDate);
      this.$refs.dateComponent.start_approval_date = '';
      this.$refs.dateComponent.end_approval_date = '';
    },
    filterAccounts() {
      this.disabledDate = false;
    },
    dateRange(date) {
      // console.log('dateRange', date.from, date.to);
      this.$emit('updateDate', date.from, date.to);
    },
    resetFilter() {
      this.activate = false;
      this.deactivate = false;
      this.disabledDate = true;
      this.selectedDate = '';
      this.$emit('updateStatus', this.activate, this.deactivate);
      this.$emit('updateDate', '', '');
      this.$refs.dateComponent.start_approval_date = '';
      this.$refs.dateComponent.end_approval_date = '';
    },
  },
};
</script>

<style scoped>
/* for radio button*/
/* [type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #0b3c61;
  border-radius: 100%;
  background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: #0b3c61;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
} */
.default-label {
  padding-left: 13px;
}

.default-label.date-field {
  margin-bottom: 12px;
}

.pl-9 {
  padding-left: 9px;
}

label > input[type="radio"] {
   display: none;
}
label > input[type="radio"] + *::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 14px;
  height: 14px;
  margin-right: 12px;
  margin-bottom: 4px;
  border-radius: 50%;
  border-style: solid;
  border-width: 1px;
  border-color: #01518a;
}
label > input[type="radio"]:checked + *::before {
  background: radial-gradient(#01518a 0%, #01518a 46%, transparent 51%, transparent);
  border-color: #01518a;
}
label > input[type="radio"]:checked + * {
  color: #01518a;
}

.pt-25 {
  padding-top: 25px;
}

.pb-18 {
  padding-bottom: 18px;
}

.filter-text-right {
  background: #FFFFFF;
  border-radius: 0px 4px 4px 0px;
  height: 48px;
  padding: 12px 0px 12px 12px;
  box-shadow: 4px 4px 10px rgb(0 0 0 / 10%);
}

.filter-section {
  font-family: 'Open Sans';
  font-style: normal;
  position: absolute;
  z-index: 3;
  left: 15px !important;
  top: -13px;
  margin-left: 0px;
  box-shadow: 4px 4px 10px rgb(0 0 0 / 10%);
}
.filter-card-header {
  background: #FFFFFF;
  box-shadow: 4px 4px 10px rgb(0 0 0 / 10%);
}

.filter-chevron-section {
  padding: 24px 24px 24px 24px;
}

.filter-compact {
  width: 74px !important;
}
.hide-field {
  display: none !important;
}
.filter-ul {
  /* padding: 16px 16px 16px 24px; */
  width: 375px;
  display: block;
  background: #FFFFFF;
  box-shadow: 4px 4px 10px rgb(0 0 0 / 10%);
  border-radius: 0px;
  border-right: 1px solid rgb(130, 130, 130, 0.4);
  border-left: 0px;
  border-top: 0px;
  border-bottom: 0px;
}

.dropdown-menu {
  margin: 0px 0px 0px;
  padding: 0px;
}

.inside-filter-text {
  font-weight: 300;
  font-size: 24px;
  line-height: 33px;
  color: #333333;
  padding-left: 16px;
}
.reset-apply-buttons {
  padding: 0px 32px 33px 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.reset-link,
.reset-link:hover,
.reset-link:focus {
  padding: 0px;
  border: none;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #01518a !important;
  background-color: transparent;
}
.apply-btn,
.apply-btn:focus,
.apply-btn:hover {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  background-color: #01518A;
  border: none;
  cursor: pointer;
  color: #ffffff;
  border-radius: 5px;
  padding: 10px 33px 9px 32px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
}
.filter-wrapper {
  padding-bottom: 44px;
  overflow: auto;
  height: 376px;
}

.account-status-carret-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.account-status-carret-section button {
  background-color: transparent !important;
  padding: 0px;
  border: none;
}
.account-status-carret-section span button[aria-expanded="true"] img.downCarret {
  display: none;
}

.account-status-carret-section span button[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
.account-status-carret-section span button img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
}
.account-status-carret-section span button img.upCarret {
  display: none;
}
.filter-options-outline {
  padding: 24px 24px 0px 24px;
}
.filter-options,
.filter-options a {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}
.record-type-item {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300 !important;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  padding-left: 28px;
}
.record-type-item label {
  font-weight: 300 !important;
}
.select-check {
  height: 11px;
  width: 11px;
  position: absolute;
  left: 1px;
  top: 1px
}
.activityTracker-checkbox>.checkbox .cr {
  border: 1px solid #01518a;
  width: 16px;
  height: 16px;
}
.activityTracker-checkbox>.checkbox label input[type="checkbox"]:checked+.cr {
  background-color: #0B3C61;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  /* border-radius: 20px; */
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;
  ;
}
</style>
